"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:6.5.3'] && _();
}
catch (e) { }
